import React, { useEffect, useState } from "react";
import { FileText, Image as ImageIcon, Film, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { fetchFileBlob, fmtSize } from "./supportUtil";

const icon = (a) => (a.kind === "image" || /^image\//.test(a.mime || "") ? ImageIcon : a.kind === "video" || /^video\//.test(a.mime || "") ? Film : FileText);

// Files are fetched with the Authorization header (no token in URLs) and shown via object URLs.
function AuthThumb({ path, alt }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let url = "", alive = true;
    fetchFileBlob(path).then((b) => { url = URL.createObjectURL(b); if (alive) setSrc(url); else URL.revokeObjectURL(url); }).catch(() => {});
    return () => { alive = false; if (url) URL.revokeObjectURL(url); };
  }, [path]);
  return src ? <img src={src} alt={alt} className="h-10 w-10 rounded-lg object-cover" /> : <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-slate-100"><ImageIcon size={14} className="text-slate-300" /></span>;
}

function AttachmentItem({ a, compact, testid }) {
  const [busy, setBusy] = useState(false);
  const Icon = icon(a); const isImg = Icon === ImageIcon;
  const open = async () => {
    const win = window.open("", "_blank");
    setBusy(true);
    try {
      const url = URL.createObjectURL(await fetchFileBlob(a.path));
      if (win) win.location.href = url; else { const l = document.createElement("a"); l.href = url; l.download = a.name || "lampiran"; l.click(); }
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch { if (win) win.close(); toast.error(`Gagal membuka ${a.name || "lampiran"}`); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={open} className="group flex items-center gap-2 rounded-xl border border-line bg-white px-2.5 py-1.5 text-xs text-slate-700 transition-colors hover:border-brand" data-testid={testid} title={a.name}>
      {isImg && !compact ? <AuthThumb path={a.path} alt={a.name} /> : <Icon size={14} className="text-slate-400 group-hover:text-brand" />}
      <span className="max-w-[160px] truncate font-semibold">{a.name}</span>
      <span className="text-[10px] text-slate-400">{fmtSize(a.size)}</span>
      {busy ? <Loader2 size={11} className="animate-spin text-brand" /> : <Download size={11} className="text-slate-300 group-hover:text-brand" />}
    </button>
  );
}

export function AttachmentList({ items = [], compact, testid = "attachments" }) {
  if (!items.length) return null;
  return (
    <ul className={`flex flex-wrap gap-2 ${compact ? "mt-2" : "mt-3"}`} data-testid={testid}>
      {items.map((a, i) => <li key={`${a.path}-${i}`}><AttachmentItem a={a} compact={compact} testid={`${testid}-${i}`} /></li>)}
    </ul>
  );
}
